import { LogManager } from '@src/utility/Logger';

// Provider interface so tests can inject mock worker easily.
export interface UploadWorkerProvider {
  get(): Worker | null;
}

const logger = LogManager.getLogger('upload:worker');

class DefaultUploadWorkerProvider implements UploadWorkerProvider {
  private worker: Worker | null = null;

  get(): Worker | null {
    if (this.worker) return this.worker;
    if (typeof Worker === 'undefined') {
      logger.warn('worker-not-supported');
      return null;
    }
    if (
      typeof navigator !== 'undefined' &&
      /jsdom/i.test(navigator.userAgent)
    ) {
      return null; // skip in Jest / jsdom
    }
    try {
      this.worker = new Worker(
        // Relative path from this file to worker file
        new URL('../../workers/s3Upload.worker.ts', import.meta.url),
        { type: 'module' },
      );
    } catch (err) {
      logger.warn('worker-init-failed', { message: String(err) });
      this.worker = null;
    }
    return this.worker;
  }
}

export function createDefaultUploadWorkerProvider(): UploadWorkerProvider {
  return new DefaultUploadWorkerProvider();
}
